import React from "react";

/**
 * Placeholder rows shown while stages are being fetched from the backend.
 */
export default function LoadingSkeleton({ rows = 5 }) {
  return (
    <div
      className="overflow-hidden rounded-xl border border-theme-200 shadow-sm"
      role="status"
      aria-label="Loading workflow stages"
    >
      <div className="bg-theme-50 px-4 py-3">
        <div className="h-4 w-32 animate-pulse rounded bg-theme-200" />
      </div>
      <div className="divide-y divide-theme-100">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="flex items-center gap-3 px-4 py-3.5">
            <div className="h-9 w-9 flex-none animate-pulse rounded-full bg-theme-100" />
            <div className="flex-1 space-y-2">
              <div className="h-3.5 w-28 animate-pulse rounded bg-theme-200" />
              <div className="h-3 w-40 animate-pulse rounded bg-theme-100" />
            </div>
            <div className="flex gap-6">
              {Array.from({ length: 4 }).map((__, j) => (
                <div
                  key={j}
                  className="h-5 w-5 animate-pulse rounded-md bg-theme-100"
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
